<template>
  <el-table-column
    prop="email"
    sortable="custom"
    label="E-mail"
    show-overflow-tooltip
    min-width="170"
  >
    <template slot-scope="scope">
      {{ scope.row.email }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'email',
};
</script>
